import script from "./ChatControl.vue?vue&type=script&lang=ts"
export * from "./ChatControl.vue?vue&type=script&lang=ts"

export default script